import { post, ServiceResult } from "@insite/client-framework/Services/ApiService";
import ApplicationState from "@insite/client-framework/Store/ApplicationState";
import { getSession } from "@insite/client-framework/Store/Context/ContextSelectors";
import { purchase } from "@WhiteCap/Common/Utillities/CustomTracking";
import { getTranslatedUom } from "@WhiteCap/Utils/UomTranslation";
import { useSelector } from "react-redux";

{
    /* EC-235 = Service to Call the Endpoint of the API and submit the form for Guest Quote */
}

// Define the interface for the Guest RFQ (Request for Quote) parameters
export interface GuestRFQParams {
    customerName: string;
    companyName: string;
    emailAddress: string;
    confirmEmailAddress: string;
    phoneNumber: number | null;
    customerNumber: string;
    customerPo: string;
    customerJob: string;
    sendCopyToEmail: string;
    sendCopyToComment: string;
    billingName: string;
    billingAddress: string;
    billingCity: string;
    billingProvince: string;
    billingPostalCode: string;
    billingCountry: string;
    isShippingSameAsBilling: boolean;
    shippingRecipientName: string;
    shippingAddress: string;
    shippingCity: string;
    shippingProvince: string;
    shippingPostalCode: string;
    shippingCountry: string;
    language?: string;
}

// Define the API parameter interface, identical to the GuestRFQParams interface
export interface GuestRFQApiParameter {
    customerName: string;
    companyName: string;
    emailAddress: string;
    confirmEmailAddress: string;
    phoneNumber: number | null;
    customerNumber: string;
    customerPo: string;
    customerJob: string;
    sendCopyToEmail: string;
    sendCopyToComment: string;
    billingName: string;
    billingAddress: string;
    billingCity: string;
    billingProvince: string;
    billingPostalCode: string;
    billingCountry: string;
    isShippingSameAsBilling: boolean;
    shippingRecipientName: string;
    shippingAddress: string;
    shippingCity: string;
    shippingProvince: string;
    shippingPostalCode: string;
    shippingCountry: string;
    language?: string;
}

// API endpoint URL for Guest RFQ submission
const GuestRFQApiUrl = "/api/v1/guestRfq";

// GuestRFQService function to handle the API call for submitting Guest RFQ
export async function GuestRFQService(parameter: GuestRFQApiParameter): Promise<ServiceResult<any>> {
    try {
        const rfqCart = localStorage.getItem("rfqCart");
        const language = document.documentElement.lang;
        let quoteProductLines: { ProductID: string; Quantity: number; UnitMeasure: string; }[] = [];
       
        if (rfqCart) {
            try {
                const cartData = JSON.parse(rfqCart);
                quoteProductLines = cartData.products.map((product: any) => ({
                    ProductID: product.id,
                    Quantity: product.qty,
                    UnitMeasure: getTranslatedUom(
                        product.unitOfMeasures?.find((item: any) => item.isDefault)?.unitOfMeasureDisplay ?? "",
                        language,
                    ),
                    // UnitMeasure: product.unitOfMeasures
                    //     ? product.unitOfMeasures.find((item: any) => item.isDefault)?.unitOfMeasureDisplay
                    //     : "",
                }));
              
            } catch (parseError) {
                return {
                    successful: false,
                    errorMessage: "Failed to parse RFQ cart data.",
                };
            }
        }

        const { confirmEmailAddress, ...payloadWithoutConfirmEmail } = parameter;

        const payload = {
            ...payloadWithoutConfirmEmail,
            quoteProductLines,
        };

        // Make the API call
        const GuestRFQModel = await post<any>(GuestRFQApiUrl, payload);
        return {
            result: GuestRFQModel,
            successful: true,
        };
    } catch (error: any) {
        if (error?.status === 400 && error?.errorJson?.message) {
            return {
                successful: false,
                errorMessage: error.errorJson.message,
            };
        }

        // Handle generic error
        return {
            successful: false,
            errorMessage: error?.message || "An unexpected error occurred.",
        };
    }
}

{
    /* EC-235 = Service to Call the Endpoint of the API and submit the form for Guest Quote */
}